module.exports = __webpack_public_path__ + "static/media/29EUNOG11.c29e51cb.jpg";